import { makeStyles } from "@mui/styles";
import { Colors } from "../helpers/Colors";
import { fontSize } from "../helpers/fontSize";

export const Modal_Input_useStyles = makeStyles({
  Container_Two: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "fit-content",
    "@media only screen and (max-Width: 500px) ": {
      flexDirection: "column",
    },
    "& .CabinName_Con": {
      display: "flex",
      flexDirection: "column",
      width: "280px",
      padding: "0px 30px 15px 0",
      "@media only screen and (max-Width: 500px) ": {
        padding: "0px 0px 10px 0",
      },
      "@media (min-Width: 500px) and (max-Width: 770px) ": {
        display: "flex",
        flexDirection: "column",
        width: "230px",
      },
      // "@media (min-Width: 770px) and (max-Width: 1100px) ": {
      //   width: "250px",
      // },
      "& label": {
        fontSize: fontSize.modalInput,
        fontWeight: 500,
        color: Colors.secondary,
        "@media only screen and (max-Width: 770px) ": {
          fontSize: fontSize.label,
        },
      },
      "& input": {
        fontWeight: 500,
        padding: "10px 10px",
        margin: "2px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.inputBg}`,
        backgroundColor: Colors.primaryExtraLight2,
        fontSize: fontSize.modalInput,
        borderRadius: "5px",
        color: Colors.secondary,
        "@media only screen and (max-Width: 770px) ": {
          //  fontSize: fontSize.label,
          padding: "6px 8px 8px 8px",
        },
        "& option": {
          maxHeight: "100px",
          overflowY: "scroll",
        },
      },
    },
    "& .Day_Con": {
      display: "flex",
      flexDirection: "column",
      width: "250px",
      padding: "0px 0px 15px 0",
      // "@media only screen and (max-Width: 1100px) ": {
      //   width: "250px",
      // },
      "@media only screen and (max-Width: 500px) ": {
        padding: "0px 0px 10px 0",
        width: "280px",
      },
      "@media (min-Width: 500px) and (max-Width: 770px) ": {
        display: "flex",
        flexDirection: "column",
        width: "230px",
      },
      "& label": {
        fontSize: fontSize.modalInput,
        fontWeight: 500,
        color: Colors.secondary,
        "@media only screen and (max-Width: 770px) ": {
          fontSize: fontSize.label,
        },
      },
      "& input": {
        fontWeight: 500,
        padding: "10px 10px",
        margin: "2px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.inputBg}`,
        backgroundColor: Colors.primaryExtraLight2,
        fontSize: fontSize.modalInput,
        borderRadius: "5px",
        color: Colors.secondary,
        "@media only screen and (max-Width: 770px) ": {
          //  fontSize: fontSize.label,
          padding: "6px 8px 8px 8px",
        },
        "& option": {
          maxHeight: "100px",
          overflowY: "scroll",
        },
      },
      "& select ": {
        fontWeight: 500,
        padding: "10px 10px",
        margin: "2px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.inputBg}`,
        backgroundColor: Colors.primaryExtraLight2,
        fontSize: fontSize.modalInput,
        borderRadius: "5px",
        color: Colors.secondary,
        "@media only screen and (max-Width: 770px) ": {
          //  fontSize: fontSize.label,
          padding: "6px 8px 8px 8px",
        },
        "& option": {
          maxHeight: "100px",
          overflowY: "scroll",
        },
      },
    },
  },
});
